import { render, staticRenderFns } from "./ChannelsTabs.vue?vue&type=template&id=5332ff3f&scoped=true&"
import script from "./ChannelsTabs.vue?vue&type=script&lang=js&"
export * from "./ChannelsTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsTabs.vue?vue&type=style&index=0&id=5332ff3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332ff3f",
  null
  
)

export default component.exports